// extracted by mini-css-extract-plugin
export default {"error_view":"styles_error_view__2zd26","error_view_btn":"styles_error_view_btn__dz25b"};